// O nome 00- eh para garantir que seja o primeiro
export default defineNuxtPlugin(() => {
  Object.keys(localStorage).forEach((key) => {
    if (
      !key.startsWith('@') ||
      key.includes('v1-userData') ||
      key.includes('v1-userActivity') ||
      key.includes('v1-userLimits') ||
      key.includes('v1-accountMenu') ||
      key.includes('v1-userActivity') ||
      key.includes('v1-smartico')
    ) {
      return;
    }

    localStorage.removeItem(key);
  });

  function diffHostname() {
    try {
      const l = location.href;
      const r = document.referrer;

      if (l && r) {
        return new URL(l).hostname !== new URL(r).hostname;
      }
    } catch (ex) {
      console.error('failed diff hostname', ex);
    }

    let onIframe = false;

    try {
      onIframe = window.location.hostname !== window.parent.location.hostname;
    } catch (ex) {
      onIframe = true;
    }

    return onIframe;
  }

  try {
    if (diffHostname()) {
      let referrer = '';

      try {
        referrer = document.referrer;
      } catch (ex) {}
      if (!referrer) {
        referrer = 'origin';
      }
      if (referrer === 'origin') {
        if (!sessionStorage.getItem('c_documentReferrerInit')) {
          sessionStorage.setItem('c_documentReferrerInit', referrer);
        }
        if (!localStorage.getItem('c_documentReferrerInitLocal')) {
          localStorage.setItem('c_documentReferrerInitLocal', referrer);
        }
      } else {
        sessionStorage.setItem('c_documentReferrerInit', referrer);
        localStorage.setItem('c_documentReferrerInitLocal', referrer);
      }
    }
  } catch (ex) {
    console.error('error set 1', ex);
  }
});
